import { render, staticRenderFns } from "./DCreateAdmin.vue?vue&type=template&id=55275eb0"
import script from "./DCreateAdmin.vue?vue&type=script&lang=js"
export * from "./DCreateAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports